import httpApi from "@/apis/httpApi";
import http from "@/utils/http.js";

// 获取下载地址
export const getGameLink = () =>
  http.httpGet({
    url: httpApi.homes.getGameLink,
  });

// 新前台日志管理接口
export const getUpdateLog = (json: any): any =>
  http.httpPost({
    url: httpApi.homes.getUpdateLog,
    json,
  });

// 获取更新日志json
export const getUserJson = () =>
  http.httpGet({
    url: httpApi.homes.getUserJson,
  });
// 获取引擎列表
export const getEngine = () =>
  http.httpGet({
    url: httpApi.homes.getEngine,
  });
interface RegisterJson {
  username: string;
  password: string;
  phone: string;
  code?: string;
}
// 官网注册
export const register = (json: RegisterJson) =>
  http.httpPost({
    url: httpApi.homes.register,
    json,
  });
interface RegisterCodeJson {
  phone: string;
}
// 官网注册 获取验证码
export const getCode = (json: RegisterCodeJson) =>
  http.httpPost({
    url: httpApi.homes.getCode,
    json,
  });
// 新游推荐
export const newGameList = (): any =>
  http.httpGet({
    url: httpApi.homes.newGameList,
  });

// 游戏详情
interface GameInfoJson {
  box_game_id: string;
}

export const gameInfo = (json: GameInfoJson): any =>
  http.httpPost({
    url: httpApi.homes.gameInfo,
    json,
  });

// 同厂推荐
interface FirmRecommendJson {
    box_game_id: string,
    factory_id: string
}
export const firmRecommend = (json: FirmRecommendJson): any => http.httpPost({
    url: httpApi.homes.firmRecommend,
    json,
})

// 获取盒子图片列表
export const getRankTop = (json: any) =>
  http.httpGet({
    url: httpApi.homes.getRankTop,
    json,
  });

// 获取合作案例
export const getCooperationList = () =>
  http.httpGet({
    url: httpApi.homes.getCooperationList,
  });

// 获取新闻列表
export const getNewsList = (json: any) =>
  http.httpGet({
    url: httpApi.homes.getNewsList,
    json
  });

// 获取新闻详情
export const getNewsDetail = (json: any) =>
  http.httpGet({
    url: httpApi.homes.getNewsDetail,
    json
  });

// 获取服务进程
export const getProcess = (json: any) =>
http.httpGet({
  url: httpApi.homes.getProcess,
  json
});

// 获取技术文档
export const getDoc = (json: any) =>
http.httpGet({
  url: httpApi.homes.getDoc,
  json
});
